/** @format */

import React, { Component } from "react";
// import Link from 'next/link'

import { Container, Row, Col, Card, CardImg, CardImgOverlay } from "reactstrap";

import NewArrivals from "../components/NewArrivals";
import Swiper from "../components/Swiper";

import data from "../data/index.json";
import products from "../data/products-clothes.json";

import Header from "../components/Header";
import Footer from "../components/Footer";
import {
  setCookie,
  getCookie,
  eraseCookie,
  setLocalStorage,
  getLocalStorage,
} from "../global/browserFunctions";
import jquery from "jquery";


class Home extends Component {
  constructor(props) {
    super(props);
    var name = getCookie("name");
    var location = getCookie("country");
    //console.log(props)
    var data = location == "US" ? window.HOME_US : window.HOME_CANADA;
    
    this.state = {
      headermenu: true,
      name: name,
      homepage: this.createhomedata(data),
      category: this.createcategorydata(data)
    };
    // console.log(window.HOME_US)

    if (!getCookie("log")) {
      this.GoToPage("/");
    }
    document.title = "Home";
  }

  

  createhomedata(data) {
    //Create banner data from window.data
    console.log('data',data)
    var arr = [];
    var obj = {};
    var variableobj = {
      1: { img: data["Banner1"].value, text: data["Banner 1 Text"].value, link: data["Banner 1 Link"].value },
      2: { img: data["Banner2"].value, text: data["Banner 2 Text"].value, link: data["Banner 2 Link"].value },
      3: { img: data["Banner3"].value, text: data["Banner 3 Text"].value, link: data["Banner 3 Link"].value },
    };
    for (var key in variableobj) {
      if(variableobj[key].img.indexOf('72067')==-1)
      {
        obj = {
          name: "",
          subtitle: variableobj[key].text,
          text: "",
          button: "Discover more",
          link: variableobj[key].link || "#",
          img: variableobj[key].img,
          bgdirection: "right",
          subtitleclass: "text-dark mb-3",
          titleclass: "display-1 mb-3",
        };
        arr.push(obj);
      }
      
    }
    //console.log(arr)
    return arr;
  }
  createcategorydata(data) {
    //Create category, banner data from window.data
    var arr = [];
    var obj = {};
    var variableobj = {
      1: { img: data["Category1"].value, text: data["Category 1 Text"].value, link: data["Category 1 Link"].value },
      2: { img: data["Category2"].value, text: data["Category 2 Text"].value, link: data["Category 2 Link"].value },
    };
    for (var key in variableobj) {
      obj = {
        img: variableobj[key].img,
        name: variableobj[key].text,
        link: variableobj[key].link
      };
      arr.push(obj);
    }
    //console.log(arr)
    return arr;
  }

  GoToPage(path) {
    this.props.history.push(path);
  }
  render() {
    return (
      <React.Fragment>
        <Header headermenu={this.headermenu} history={this.props.history} />
        <Swiper
          data={this.state.homepage}
          autoplay
          delay={5000}
          loop
          slidesPerView={1}
          spaceBetween={0}
          centeredSlides
          speed={1500}
          parallax
          navigation
          style={{ height: "95vh", minHeight: "600px" }}
          containerclass="px-lg-7"
        />
        {this.state.category && (
          <div className="bg-gray-100 position-relative">
            <Container className="py-6">
              <Row>
                {this.state.category.map((category) => (
                  <Col key={category.name} sm="6" className="mb-5 mb-sm-0">
                    <Card className="mb-5 border-0 text-white dark-overlay card-scale shadow-0 border-0 overlay-hover-light">
                      <img
                        src={category.img}
                        alt={category.name}
                        className="card-img"
                      />
                      <a href={category.link} className="tile-link text-white">
                        <div className="card-img-overlay d-flex align-items-center">
                          <div className="text-center w-100 overlay-content">
                            <h4 className="display-4 font-weight-bold mb-0">
                              {category.name}
                            </h4>
                          </div>
                        </div>
                      </a>
                    </Card>
                  </Col>
                  // <Col key={category.name} sm='6' className='mb-5 mb-sm-0'>
                  // 	<Card className='card-scale shadow-0 border-0 text-primary text-hover-gray-900 overlay-hover-light text-center'>
                  // 		<CardImg
                  // 			className='img-scale'
                  // 			src={category.img}
                  // 			alt={category.name}
                  // 		/>
                  // 		<CardImgOverlay className='d-flex align-items-center'>
                  // 			<div className='w-100 py-3'>
                  // 				<h4 className='display-4 font-weight-bold mb-0'>
                  // 					{category.name}
                  // 				</h4>
                  // 				<a href={category.link} className='stretched-link'>
                  // 					<span className='sr-only'>{category.button}</span>
                  // 				</a>
                  // 			</div>
                  // 		</CardImgOverlay>
                  // 	</Card>
                  // </Col>
                ))}
              </Row>
            </Container>
          </div>
        )}
        {/* <NewArrivals fluid headCenter products={products} /> */}
        {/* <Sale className="py-6" backgroundImage='/img/photo/deal-plain.jpg'/> */}
        {/* <OurHistory />
      <Brands className="pb-6"/> */}
        <Footer />
      </React.Fragment>
    );
  }
}

export default Home;
